import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import { Grid, Toolbar, Alert } from "@mui/material";

import loaderGif from "assets/img/loading.gif";

import {
  cardBodyStyle,
  AppBarStyle,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

import logoUsame from "assets/img/logo-Usame-web-color.png";

const useStyles = makeStyles(cardBodyStyle);

export default function PaymentsNotification(props) {
  const classes = useStyles();

  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [loader, setLoader] = useState(true);
  const [alert, setAlert] = useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
    img: "",
  });

  const { urlServices } = useContext(UrlServicesContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RowsDatas();
  }, []);

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
    setLoader(false);
  };

  const RowsDatas = async () => {
    setLoader(true);
    const values = {
      status: {
        status: "REJECTED",
        message: "Testing notification",
        reason: "?C",
        date: "2025-02-17T14:20:25-05:00",
      },
      requestId: 849808,
      reference: "08228955",
      signature: "a03dae324e6c76ad26308e5fbb34e47c8318b965",
    };

    try {
      const response = await axios.post(
        `${urlServices}placetopay/notification`,
        values
      );
      if (response.status === 200) {
        setAlert({
          openAlert: true,
          errorAlert: "info",
          mensaje: "¡PROCESADO!",
          reference: "",
          date: "",
          price: "",
          receipt: null,
          img: "",
        });

        setLoader(false);
      }
    } catch (error) {
      handleError(error);
    }
  };

  return (
    <Fragment>
      <AppBarStyle position="static">
        <Toolbar sx={{ minHeight: "50px !important" }}>
          <img
            src={logoUsame}
            alt="logoheader"
            style={{ width: 70, marginLeft: "5%" }}
          />
        </Toolbar>
      </AppBarStyle>

      <center>
        <Grid
          container
          spacing={2}
          className={classes.containerProfile}
          sx={{ width: "80%", margin: "40px 0 0 8px" }}
        >
          <Grid item xs={12}>
            {error && <Alert severity="error">{mensageSystem}</Alert>}
          </Grid>
          {loader ? (
            <Grid item xs={12} sm={12}>
              <center>
                <img
                  alt="loaderGif"
                  src={loaderGif}
                  style={{ width: 60, margin: "20% 0" }}
                />
              </center>
            </Grid>
          ) : (
            <>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Alert severity={"info"} icon={false} sx={{ fontSize: 20 }}>
                  {alert.mensaje}
                </Alert>
              </Grid>
              <Grid item xs={12} sx={{ paddingTop: 10 }}>
                <center>
                  <ButtonStyle0 href="https://usamebpo.com/">
                    Salir de la ventana
                  </ButtonStyle0>
                </center>
              </Grid>
            </>
          )}
        </Grid>
      </center>
    </Fragment>
  );
}
